import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { ApiRouting } from "@globals/classes/ApiRouting";
import { CreateLogCommand } from "@globals/openapi-models/model/createLogCommand";
import { LogLevel } from "@globals/openapi-models/model/logLevel";

@Injectable({
  providedIn: "root"
})
export class LogBaseService {
  protected readonly httpClient = inject(HttpClient);

  /**
   * For logging an error in server database
   */
  public createLog(err: HttpErrorResponse | { message: string; stack?: string }, module: string) {
    const command = <CreateLogCommand>{
      logLevel: LogLevel.Error,
      module: module,
      shortMessage: `Client side error occured: ${err.message}`,
      fullMessage: err instanceof HttpErrorResponse ? `${err.name}:\n ${err.message}` : `${err.message}:\n ${err.stack}`
    };

    return this.httpClient.post(ApiRouting.logRoutes.post.create, command);
  }
}
